import { createApp } from 'vue'
import ProfileCard from './index.vue'

function createProfileCard (cfg) {

  const vm = createApp(ProfileCard).mount(cfg.selector);

  vm.applyConfig(cfg);

  return;
}

export default createProfileCard;
